/**
 * OutlineView — full-width inline editing surface for all non-hero/non-footer sections.
 * Each section renders as a stacked SectionContextPanel (inline mode) so users can
 * edit content without leaving outline view. Visual changes are visible on switch back.
 */
import type { PageSection } from "@/templates/types"
import { SectionContextPanel } from "./SectionContextPanel"

export interface OutlineViewProps {
  sections: PageSection[]
  primaryColor: string
}

const EXCLUDED_TYPES = new Set(["hero", "footer"])

export function OutlineView({ sections, primaryColor }: OutlineViewProps) {
  const sorted = [...sections]
    .filter((s) => !EXCLUDED_TYPES.has(s.section_type))
    .sort((a, b) => a.order_index - b.order_index)

  if (sorted.length === 0) {
    return (
      <div
        style={{
          background: "rgba(12,12,16,0.97)",
          padding: 32,
          textAlign: "center",
          fontSize: 13,
          color: "rgba(255,255,255,0.35)",
        }}
      >
        No editable sections on this page.
      </div>
    )
  }

  return (
    <div style={{ background: "rgba(12,12,16,0.97)" }}>
      {sorted.map((section) => (
        <SectionContextPanel
          key={section.id}
          section={section}
          primaryColor={primaryColor}
          onClose={() => {}}
          inline
        />
      ))}
    </div>
  )
}
